<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="3">SEGURADO</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>{{
            getNameLabel(
              proposalData.dadosCliente.cpf,
              proposalData.dadosCliente.associadoNomeSocial,
            )
          }}</b
          >:
          {{
            proposalData.dadosCliente.associado
              ? proposalData.dadosCliente.associado
              : ''
          }}
        </td>
        <td
          class="pl-3"
          v-if="
            isIndividualPerson(proposalData.dadosCliente.cpf) &&
            !proposalData.dadosCliente.associadoNomeSocial
          "
        >
          <b>Nome Social:</b>
        </td>
        <td class="pl-3">
          <b>{{
            isIndividualPerson(proposalData.dadosCliente.cpf) ? 'CPF' : 'CNPJ'
          }}</b
          >:
          {{
            proposalData.dadosCliente.cpf ? proposalData.dadosCliente.cpf : ''
          }}
        </td>
      </tr>
      <tr v-if="isIndividualPerson(proposalData.dadosCliente.cpf)">
        <td class="pl-3">
          <b>Data de Nascimento</b>:
          {{
            proposalData.dadosCliente.dataNascimento != 'Invalid date'
              ? proposalData.dadosCliente.dataNascimento
              : ''
          }}
        </td>
        <td class="pl-3" colspan="2">
          <b>Sexo de Nascimento</b>:
          {{
            proposalData.dadosCliente.sexo ? proposalData.dadosCliente.sexo : ''
          }}
        </td>
      </tr>
      <tr>
        <td class="pl-3">
          <b>E-mail</b>:
          {{
            proposalData.dadosCliente.email
              ? proposalData.dadosCliente.email
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Celular</b>:
          {{
            proposalData.dadosCliente.celular
              ? proposalData.dadosCliente.celular
              : ''
          }}
        </td>
      </tr>
      <tr v-if="isIndividualPerson(proposalData.dadosCliente.cpf)">
        <td class="pl-3">
          <b>Estado Civil</b>:
          {{
            proposalData.dadosCliente.estadoCivil
              ? proposalData.dadosCliente.estadoCivil
              : ''
          }}
        </td>
        <td class="pl-3" colspan="2">
          <b>É uma pessoa politicamente exposta (PPE)?</b>:
          {{ proposalData.dadosCliente.politicamenteExposto ? 'Sim' : 'Não' }}
        </td>
      </tr>
      <tr v-if="proposalData.dadosCliente.politicamenteExposto">
        <td class="pl-3">
          <b>Tipo de PPE</b>:
          {{
            proposalData.dadosCliente.ppeDescription
              ? proposalData.dadosCliente.ppeDescription
              : ''
          }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.INSURED"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.INSURED"
    ></div>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractInsured',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
    };
  },
  methods: {
    getNameLabel(documentId, hasSocialName) {
      if (this.isIndividualPerson(documentId)) {
        return hasSocialName ? 'Nome Social' : 'Nome';
      }
      return 'Razão Social';
    },
    isIndividualPerson(cpf) {
      return cpf.length <= 14 ? true : false;
    },
  },
};
</script>

<style scoped>
.assinatura {
  border-top: 0.1rem solid #626262;
  margin: 0 1rem 0 1rem;
  padding-top: 0.5rem;
}
</style>
